import type { AxiosError } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { BillingItem } from '@/types/encounter';
import RepositoryResponse from '@/types/repositoryResponse';
import ajax from '@/utils/ajax';
import defaultRepositoryError from '@/utils/defaultRepositoryError';

export const billingItemsRepository = {
  async refresh({
    host,
    billingItemId
  }: {
    host: string;
    billingItemId: string;
  }): Promise<RepositoryResponse<BillingItem>> {
    try {
      const path = `/api/dugout/billing_items/${billingItemId}/refresh/`;
      const response = await ajax.post({
        url: `${host}${path}`,
        data: {
          id: billingItemId
        }
      });

      return {
        data: response.data as BillingItem,
        isError: false
      };
    } catch (error) {
      return defaultRepositoryError(error as AxiosError, 'Failed to refresh billing item.');
    }
  }
};

const BillingItemsRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async refreshItem({
      billingItemId
    }: {
      billingItemId: string;
    }): Promise<RepositoryResponse<BillingItem>> {
      return billingItemsRepository.refresh({
        host,
        billingItemId
      });
    }
  };
};

export default BillingItemsRepository;
